import type { EntityType, FlowType } from 'consts/flows';
import { ENTITY_TYPE, FLOW_TYPE } from 'consts/flows';
import { QuestionnaireType, type QuestionnaireTypeNumber } from 'consts/statuses';

const INDIVIDUAL_QUESTIONNAIRE: Record<string, QuestionnaireTypeNumber> = {
	[FLOW_TYPE.EB]: QuestionnaireType.SuitabilityPrivateBankingIndividual,
	[FLOW_TYPE.ER]: QuestionnaireType.SuitabilityAssetCounselingIndividual,
	[FLOW_TYPE.ES_MV]: QuestionnaireType.Sustainability,
	[FLOW_TYPE.MV]: QuestionnaireType.AppropriatenessStandard,
	[FLOW_TYPE.RR_EB]: QuestionnaireType.SuitabilityPrivateBankingIndividual,
	[FLOW_TYPE.RR_ER]: QuestionnaireType.SuitabilityAssetCounselingIndividual,
	[FLOW_TYPE.RR_MV]: QuestionnaireType.AppropriatenessStandard,
	[FLOW_TYPE.RR_SU]: QuestionnaireType.Sustainability
};

const COMPANY_QUESTIONNAIRE: Record<string, QuestionnaireTypeNumber> = {
	[FLOW_TYPE.EB]: QuestionnaireType.SuitabilityPrivateBankingCompany,
	[FLOW_TYPE.ER]: QuestionnaireType.SuitabilityAssetCounselingCompany,
	[FLOW_TYPE.MV]: QuestionnaireType.AppropriatenessStandard,
	[FLOW_TYPE.RR_EB]: QuestionnaireType.SuitabilityPrivateBankingCompany,
	[FLOW_TYPE.RR_ER]: QuestionnaireType.SuitabilityAssetCounselingCompany,
	[FLOW_TYPE.RR_MV]: QuestionnaireType.AppropriatenessStandard,
	[FLOW_TYPE.RR_SU]: QuestionnaireType.Sustainability
};

const ENTITY_TYPE_MAP = {
	[ENTITY_TYPE.INDIVIDUAL]: INDIVIDUAL_QUESTIONNAIRE,
	[ENTITY_TYPE.LEGAL_ENTITY]: COMPANY_QUESTIONNAIRE
};

type BaseTestType = 'appropriateness' | 'suitability';
type TestType = BaseTestType | 'sustainability';

export function getQuestionnaireType(
	entityType: EntityType,
	flowType: FlowType,
	testType: BaseTestType
): QuestionnaireTypeNumber {
	const fixedTestType = fixTestType(flowType, testType);

	if ('appropriateness' === fixedTestType) {
		return QuestionnaireType.AppropriatenessStandard;
	}

	const map = ENTITY_TYPE_MAP[entityType];
	return flowType in map ? map[flowType] : QuestionnaireType.AppropriatenessStandard;
}

function fixTestType(flowType: FlowType, testType: BaseTestType): TestType {
	if (FLOW_TYPE.ES_MV === flowType || FLOW_TYPE.RR_SU === flowType) {
		return 'sustainability';
	}
	return testType;
}
